import { createBrowserRouter, Outlet } from "react-router";
import { useVeil } from "./lib/veil";
import { Landing } from "./routes/landing";
import AboutPage from "./routes/about";
import IntegrationsPage from "./routes/integrations";
import PrivacyPage from "./routes/privacy";
import SupportPage from "./routes/support";
import TermsPage from "./routes/terms";

/**
 * The landing page, the about and integrations pages, the two legal pages
 * the footer links to, and the support page the App Store listing names.
 *
 * Terms and privacy came across from hireos-intake's `web/` when the apex
 * moved here (CARWHO/hireos-site#1): hireos.co.nz is this site now, so a
 * footer link to /privacy had nothing to render. They are a copy rather than
 * a shared package — the Customer-facing forms on the tenant subdomains still
 * serve their own, and the two are the same words until somebody changes one.
 */
/** Every page is under the loading screen until it has loaded (src/lib/veil.ts). */
function Root() {
  useVeil();
  return <Outlet />;
}

export const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      { path: "/", element: <Landing /> },
      { path: "/about", element: <AboutPage /> },
      { path: "/integrations", element: <IntegrationsPage /> },
      { path: "/terms", element: <TermsPage /> },
      { path: "/privacy", element: <PrivacyPage /> },
      { path: "/support", element: <SupportPage /> },
    ],
  },
]);
